import { C } from '../theme/palette';
import { fmtH } from '../lib/currency';
import { trf } from '../lib/i18n';

/**
 * Les sorties du dépôt : qui, quel jour et à quelle heure, pour quel chantier,
 * quel matériel. Les anciennes feuilles portaient aussi des heures de travail. L'employé y relit les siennes ; le patron, celles d'un employé.
 *
 * @param {object} props
 * @param {Array} props.feuilles feuilles à lister, les plus récentes d'abord
 * @param {string} [props.titre] intitulé au-dessus de la liste
 * @param {number} [props.max] nombre de feuilles affichées
 * @param {Array} [props.employes] fiches, pour nommer le magasinier qui a rempli
 */
export function ListeFeuillesDepot({
  feuilles,
  titre = 'Historique des sorties',
  max = 12,
  employes = [],
}) {
  if (!(feuilles || []).length) return null;
  const nomDe = (id) => (employes || []).find((e) => e.id === id)?.nom;
  return (
    <div style={{ marginTop: 16 }}>
      <div
        style={{
          fontSize: 9,
          fontWeight: 800,
          color: C.muted,
          textTransform: 'uppercase',
          letterSpacing: 0.4,
          marginBottom: 6,
        }}
      >
        {titre}
      </div>
      {feuilles.slice(0, max).map((f) => {
        const parMagasinier = f.par === 'magasinier';
        const magasinier = parMagasinier && f.saisiParId != null ? nomDe(f.saisiParId) : null;
        return (
          <div
            key={f.id}
            style={{
              border: '1px solid ' + C.border,
              borderRadius: 11,
              padding: '10px 12px',
              marginBottom: 8,
            }}
          >
            <div style={{ fontSize: 11, fontWeight: 800 }}>
              {f.date} · {f.empNom}
            </div>
            <div style={{ fontSize: 9.5, color: C.grey, marginTop: 3, lineHeight: 1.5 }}>
              🏗 {f.chNom}
              {f.adr ? (
                <>
                  {' '}
                  <br />
                  📍 {f.adr}
                </>
              ) : null}
              <br />
              🕒{' '}
              {+f.heures > 0
                ? f.heuresLbl || fmtH(+f.heures)
                : f.deb
                  ? trf('pris à {0}', f.deb)
                  : '—'}
              {f.travaux ? (
                <>
                  <br />
                  📝 {f.travaux}
                </>
              ) : null}
              <br />
              📦{' '}
              {f.lignes && f.lignes.length
                ? f.lignes.map((l) => (l.qte ?? l.q) + '× ' + (l.nom ?? l.d)).join(', ')
                : '—'}
            </div>
            <span
              style={{
                display: 'inline-block',
                fontSize: 8,
                fontWeight: 800,
                padding: '2px 7px',
                borderRadius: 999,
                marginTop: 6,
                color: parMagasinier ? C.amber : C.teal,
                background: parMagasinier ? C.amberL : C.tealL,
              }}
            >
              {parMagasinier
                ? 'rempli par le magasinier' + (magasinier ? ' (' + magasinier + ')' : '')
                : "rempli par l'employé"}
            </span>
          </div>
        );
      })}
    </div>
  );
}
